// Phase 2A — sections/bpf-partner-landing.liquid.
//
// Three jobs, kept separate on purpose (same structure as Phase 1's own
// bpf-partner-preview.js):
//   1. Accessible breed-picker MODAL open/close — a genuine viewport-
//      centered dialog (position: fixed + flex-centered parent in
//      assets/bpf-partner-landing.css), reusing the SAME shared
//      trapFocus()/removeTrapFocus() from assets/global.js Phase 1
//      already proved out — never a second/competing focus-trap
//      implementation. Escape, backdrop click, and the X all close it;
//      focus always returns to the Dog/Cat button that opened it.
//   2. Partner-window presentation (BPF shell suppression + branding/
//      close chrome), delegated entirely to
//      window.BPFPartnerMode.initPartnerWindowPresentation() — this file
//      never re-implements that gate.
//   3. Partner context propagation onto every breed link, delegated
//      entirely to window.BPFPartnerMode.rewriteLinks() — breed
//      selection is then just an ordinary <a> navigation, no second
//      breed-to-collection mapping exists here.
(function () {
  'use strict';

  function initModals(root) {
    var triggers = root.querySelectorAll('[data-bpf-partner-landing-panel-trigger]');
    if (!triggers.length) return;

    var lastTrigger = null;

    function getPanel(id) {
      return document.querySelector('[data-bpf-partner-landing-panel="' + id + '"]');
    }

    function openPanel(id, trigger) {
      var panel = getPanel(id);
      if (!panel) return;
      lastTrigger = trigger;
      panel.hidden = false;
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var closeButton = panel.querySelector('[data-bpf-partner-landing-panel-close]');
      if (typeof trapFocus === 'function') trapFocus(panel, closeButton || panel);
      dispatchAnimalSelected(trigger);
    }

    function closePanel(panel) {
      if (!panel || panel.hidden) return;
      panel.hidden = true;
      document.body.style.overflow = '';
      var id = panel.getAttribute('data-bpf-partner-landing-panel');
      var trigger = root.querySelector('[data-bpf-partner-landing-panel-trigger="' + id + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(lastTrigger || trigger);
      lastTrigger = null;
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openPanel(trigger.getAttribute('data-bpf-partner-landing-panel-trigger'), trigger);
      });
    });

    document.querySelectorAll('[data-bpf-partner-landing-panel]').forEach(function (panel) {
      panel.querySelectorAll('[data-bpf-partner-landing-panel-close]').forEach(function (closeButton) {
        closeButton.addEventListener('click', function () {
          closePanel(panel);
        });
      });
      var backdrop = panel.querySelector('[data-bpf-partner-landing-panel-backdrop]');
      if (backdrop) {
        backdrop.addEventListener('click', function () {
          closePanel(panel);
        });
      }
      panel.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') closePanel(panel);
      });

      var titleEl = panel.querySelector('.bpf-partner-landing__modal-title');
      panel.querySelectorAll('.bpf-partner-landing__modal-link').forEach(function (breedLink) {
        breedLink.addEventListener('click', function () {
          dispatchBreedSelected(titleEl ? titleEl.textContent.trim() : null, breedLink.textContent.trim());
        });
      });
    });
  }

  function dispatchAnimalSelected(trigger) {
    if (!window.BPFPartnerMode || !window.BPFPartnerMode.isActive()) return;
    var labelEl = trigger && trigger.querySelector('.bpf-partner-landing__nav-label');
    var animal = labelEl ? labelEl.textContent.trim() : null;
    window.BPFPartnerMode.dispatchPartnerEvent('partner_animal_selected', {
      partner_id: window.BPFPartnerMode.getPartnerId(),
      animal: animal,
    });
    if (typeof window.BPFPartnerMode.sendPartnerTelemetry === 'function') {
      window.BPFPartnerMode.sendPartnerTelemetry('partner_animal_selected', {
        partnerId: window.BPFPartnerMode.getPartnerId(),
        partnerSessionId: window.BPFPartnerMode.getPartnerSessionId(),
        stage: 'landing',
        animal: animal,
      });
    }
  }

  function dispatchBreedSelected(animal, breed) {
    if (!window.BPFPartnerMode || !window.BPFPartnerMode.isActive()) return;
    window.BPFPartnerMode.dispatchPartnerEvent('partner_breed_selected', {
      partner_id: window.BPFPartnerMode.getPartnerId(),
      animal: animal,
      breed: breed,
    });
    if (typeof window.BPFPartnerMode.sendPartnerTelemetry === 'function') {
      window.BPFPartnerMode.sendPartnerTelemetry('partner_breed_selected', {
        partnerId: window.BPFPartnerMode.getPartnerId(),
        partnerSessionId: window.BPFPartnerMode.getPartnerSessionId(),
        stage: 'landing',
        animal: animal,
        breed: breed,
      });
    }
  }

  function initPartnerContext(root) {
    if (!window.BPFPartnerMode || !window.BPFPartnerMode.hasPartnerParam) return;

    window.BPFPartnerMode.initPartnerWindowPresentation();

    window.BPFPartnerMode.resolveContext().then(function (ctx) {
      if (!ctx.valid) return; // fail closed: generic copy already server-rendered stays exactly as-is
      window.BPFPartnerMode.dispatchPartnerEvent('partner_preview_loaded', {
        partner_id: ctx.partnerId,
      });
      // Appends partner/mode/parent_origin onto every breed/animal link
      // in the whole page (both the top-level direct links and every
      // link inside the breed-picker modals) — never a second mapping.
      window.BPFPartnerMode.rewriteLinks(document.body);
    });
  }

  function init(root) {
    initModals(root);
    initPartnerContext(root);
  }

  document.querySelectorAll('[data-bpf-partner-landing]').forEach(init);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-bpf-partner-landing]');
    if (section) init(section);
  });
})();
